module.exports = __webpack_public_path__ + "img/high-efficiency.f41c8c8c.jpg";